import { Cefr, Skill } from "src/app/shared/models/placement-question.model";

export const VALID_GAME_TYPES: IGameTypes[] = [
	{
		name: 'Fill The Gaps Text',
		activity: 'text-fill-the-gaps',
		skill: 'Reading',
	},
	{
		name: 'Ordering Dialogue',
		activity: 'ordering-dialogue',
		skill: 'Reading',
	},
	{
		name: 'Speaking Dialogue',
		activity: 'speaking-dialogue',
		skill: 'Speaking',
	},
	{
		name: 'Drag and Drop Placement',
		activity: 'drag-drop-placement',
		skill: 'Listening',
	},
	{
		name: 'Multichoice Placement',
		activity: 'multichoice-placement',
		skill: 'Listening',
	},
	{
		name: 'Match Game',
		activity: 'bubble-quiz-match',
		skill: 'Listening',
	},
	{
		name: 'Coloring Placement',
		activity: 'coloring-placement',
		skill: 'Listening',
	},
	{
		name: 'Ordering Letters',
		activity: 'ordering-letters',
		skill: 'Reading',
	},
	{
		name: 'Multichoice Fill The Gaps',
		activity: 'multichoice-fill-the-gaps',
		skill: 'Reading',
	},
	{
		name: 'Fill The Gaps Image',
		activity: 'fill-the-gaps-image',
		skill: 'Reading',
	}
]

export class IGameTypes {
	name!: string;
	activity!: string;
	skill!: Skill;
}
